<template>
  <v-footer padless>
    <v-main>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-btn
              text
              class="body-2 font-weight-light"
              :to="{ path: '/auth/privacystatement' }"
              >{{ this.$t("button.privacy_statement") }}</v-btn
            >
            <v-btn
              text
              class="body-2 font-weight-light"
              :to="{ path: '/auth/termsandconditions' }"
              >{{ this.$t("button.terms_and_conditions") }}</v-btn
            >
          </v-col>
        </v-row>
        <v-row v-if="$store.state.config.template_settings.footer_html">
          <span
            style="width: 100%"
            v-html="$store.state.config.template_settings.footer_html"
          ></span>
        </v-row>
      </v-container>
    </v-main>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.theme--light.v-footer {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
}
</style>
